import React from 'react';
import { makeStyles } from '@material-ui/core';
import OrderProduct from './OrderProduct';
import { OrderProduct as OrderProductType } from 'types/product';
import OrderNoItem from './OrderNoProducts';
import FabButton from './FabButton';

const styles = makeStyles(theme => ({
  ul: {
    display: 'grid',
    gridAutoRows: 'min-content',
    gap: 10,
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
    },
  },
}));

interface OrderProductsProps {
  products: OrderProductType[];
}

const OrderProducts: React.FC<OrderProductsProps> = ({ products }) => {
  const classes = styles();

  return (
    <div>
      {products.length ? (
        <ul className={classes.ul}>
          {products.map(product => {
            return <OrderProduct product={product} key={product.productId} />;
          })}
        </ul>
      ) : (
        <OrderNoItem />
      )}

      <FabButton />
    </div>
  );
};

export default OrderProducts;
